//// Application Packages
import React from 'react'

//// Application Slices

//// Application Components

//// Carbon Components
import {
    DataTable,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableHeader,
    TableBody,
    TableCell,
    Button,
} from '@carbon/react'

//// Carbon Icons
import { TrashCan } from '@carbon/icons-react'

//// Static Constants

//////// Component
const FileUploadDataTableComponent = ({
    title,
    rowData,
    headerData,
    handleFileUploadDelete,
}) => {
    //////// Hooks

    //////// State

    //////// Slices

    //// Slice Data

    //////// Search Params

    //////// Methods

    //////// Functional Methods

    //////// Memoization

    //////// Effects/Side Effects

    //////////////// Render & Return

    return (
        <>
            <DataTable rows={rowData} headers={headerData}>
                {({ rows, headers, getHeaderProps, getTableProps }) => (
                    <TableContainer title={title ? title : ''}>
                        <Table {...getTableProps()}>
                            <TableHead>
                                <TableRow>
                                    {headers?.map((header, i) => (
                                        <TableHeader
                                            key={i}
                                            {...getHeaderProps({ header })}
                                        >
                                            {header?.header
                                                ? header?.header
                                                : ''}
                                        </TableHeader>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rows?.map((row) => (
                                    <TableRow key={row?.id}>
                                        {row?.cells?.map((cell) => {
                                            if (
                                                cell?.['info']?.['header'] ===
                                                'remove_file'
                                            ) {
                                                return (
                                                    <TableCell key={cell?.id}>
                                                        <div className="half-width-button-with-icon-group">
                                                            <div className="half-width-button-with-icon-group-item">
                                                                <Button
                                                                    className="fldoh-btn"
                                                                    name={
                                                                        cell?.value
                                                                    }
                                                                    type="button"
                                                                    kind="danger"
                                                                    size="md"
                                                                    onClick={
                                                                        handleFileUploadDelete
                                                                    }
                                                                >
                                                                    Remove
                                                                    <TrashCan />
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </TableCell>
                                                )
                                            } else {
                                                return (
                                                    <TableCell key={cell?.id}>
                                                        {cell?.value
                                                            ? cell?.value
                                                            : ''}
                                                    </TableCell>
                                                )
                                            }
                                        })}
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </DataTable>
        </>
    )
}

export default FileUploadDataTableComponent
